import { jsx as _jsx } from "react/jsx-runtime";
import HistoryIcon from '@mui/icons-material/History';
import HubIcon from '@mui/icons-material/Hub';
import { DHA_NAV_ITEMS } from './data-hydration-admin/navConfig';
import { ROLLBACK_NAV_ITEMS } from './tool2/navConfig';
export const TOOL_VISUAL_REGISTRY = {
    'data-hydration-admin': {
        icon: _jsx(HubIcon, { sx: { fontSize: 48 } }),
        accentColor: '#1565c0',
        navItems: DHA_NAV_ITEMS
    },
    tool2: {
        icon: _jsx(HistoryIcon, { sx: { fontSize: 48 } }),
        accentColor: '#b71c1c',
        navItems: ROLLBACK_NAV_ITEMS
    }
};
